import { attemptChunkReload } from "@cynthai/ui";

import { getFaro } from "@/core/lib/observability";

export { scheduleChunkGuardReset } from "@cynthai/ui";

export type ChunkReloadSource = "window" | "modal" | "query" | "mutation";

// shared entry point for every place that catches errors itself and would
// otherwise swallow a stale-chunk failure (modal loader, SSE pipelines, global
// listeners). Emits a Faro event so reload frequency per deploy is observable.
export function handleChunkLoadError(
  error: Error | string,
  source: ChunkReloadSource,
): boolean {
  const reloaded = attemptChunkReload(error);
  if (reloaded) {
    getFaro()?.api.pushEvent("chunk_reload_triggered", { source });
  }
  return reloaded;
}
